import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { authenticateEmail } from '../auth/auth-slice';
import { useNavigate } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Button } from 'semantic-ui-react';

const page = 'verifyEmailPage';

export function VerifyEmailPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [formFields, setFormFields] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const { showErrorMessage, itemAssignmentCode } = useSelector((state) => ({
    emailAuthenticated:
      state.auth.user.emailAuthenticated && state.auth.user.email === state.auth.user.itemAssigneeEmail,
    showErrorMessage: state.auth.user.emailAuthenticationErrors && state.auth.user.emailAuthenticationErrors.length > 0,
    itemAssignmentCode: state.auth.user.itemAssignmentCode,
  }));

  useEffect(() => {
    if (showErrorMessage) {
      setIsLoading(false);
    }
  }, [showErrorMessage]);

  const handleSubmit = (event) => {
    setIsLoading(true);
    event.preventDefault();
    dispatch(authenticateEmail({ email: formFields['email'], code: itemAssignmentCode, navigate: navigate }));
  };

  const captureFieldValue = (e) => {
    setFormFields({ ...formFields, [e.target.name]: e.target.value });
  };

  return (
    <div className="verify-email page">
      <div className="ui card">
        <div className="ui one column grid content custom-card">
          <form onSubmit={handleSubmit}>
            <div className="ui row">
              <h2 className="ui header">
                <p>
                  <i className="lock icon"></i>
                  <FormattedMessage id="common.verifyIdentity" defaultMessage="Verify your identity" />
                </p>
              </h2>
              <div className="sub-header">
                <FormattedMessage
                  id={`${page}.message`}
                  defaultMessage="Protecting your information is important to us. Please confirm your identity by entering your email address and we’ll email a security code to authenticate."
                />
              </div>
            </div>

            <div>
              <div className="login-field-label">
                <FormattedMessage id={`${page}.email`} defaultMessage="Email Address" />
              </div>
            </div>

            <div>
              <input name="email" type="email" onChange={captureFieldValue} />
            </div>
            {showErrorMessage && (
              <div className="ui pointing basic label form-error-message">
                <FormattedMessage id={`${page}.incorrect`} defaultMessage="Incorrect email address" />
              </div>
            )}
            <div className="ui row">
              <Button className="ui green" disabled={isLoading}>
                <FormattedMessage id={`${page}.sendSecurityCode`} defaultMessage="Send Security Code" />
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
